import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';

export const PatientPicker: React.FC = () => {
  const { patients } = useAuth();
  const navigate = useNavigate();

  if (patients.length === 0) {
    navigate('/login');
    return null;
  }

  if (patients.length === 1) {
    navigate(`/patient/${patients[0].id}`, { replace: true });
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow">
        <h2 className="text-2xl font-bold text-center mb-6">Select Patient</h2>
        <div className="space-y-3">
          {patients.map((patient) => (
            <button
              key={patient.id}
              onClick={() => navigate(`/patient/${patient.id}`)}
              className="w-full text-left p-4 rounded border border-gray-200 hover:border-blue-500 hover:bg-blue-50"
            >
              {patient.first_name} {patient.last_name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};